import { Component, ComponentInterface, Prop } from '@stencil/core';

import { uniWatermark } from '@uni/license';

@Component({ tag: 'uni-analytics' })
export class UniAnalyticsComponent implements ComponentInterface {

  @Prop({ reflect: true }) code!: string;

  componentDidLoad(): void {
    uniWatermark('pro');

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.code}`;

    document.getElementsByTagName('head')[0].appendChild(script);

    window['dataLayer'] = window['dataLayer'] || [];

    function gtag() {
      window['dataLayer'].push(arguments);
    }

    // @ts-ignore
    gtag('js', new Date());
    // @ts-ignore
    gtag('config', this.code);
  }
}
